import uTitle from './uTitle';
export default uTitle;



// WEBPACK FOOTER //
// ./src/components/uTitle/index.js